<template>
  <div class="cb-pbody__wrap" ref="wrap" id="cb-pbody-wrap">
    <div class="cb-pbody__content">
      <div class="cb-u-mandate" v-if="canShowMandateText">
        <cb-notes slot="notes" :custom-class="'cb-section'" :type="'warning'" :message="eMandateTxt"></cb-notes>
      </div>
      <ul class="cb-u-invoice" v-if="inited">
        <li class="cb-u-invoice__list" v-for = "(item,index) in valid_invoices" v-bind:key="index">
          <div class="cb-u-invoice__sno">
            <div class="cb-u-invoice__radio" :class="{'cb-u-invoice__radio--active': item.selected_for_pm}" @click="partial_pm(item)" :style="item.selected_for_pm && [themeColor,backgroundColor]" tabindex="0" @keyup.enter="partial_pm(item)">
              <i class="icon-check cb-u-invoice__icon" aria-hidden="true"></i>  
            </div>
          </div>
          <div class="cb-u-invoice__info">
            <div class="cb-u-invoice__name">{{st('invoice_number', {invoice_no: item.id})}}</div>
            <div class="cb-u-invoice__amount">{{ item.amount_to_collect | cbCurrency(item.currency_code) }}</div>
          </div>
          <div class="cb-u-invoice__details">
            <div class="cb-u-invoice__detail">
              <span class="cb-u-invoice__middle" v-if="isFuture(item.due_date)">{{st('due_on')}}</span>
              <span class="cb-u-invoice__middle" v-else>{{st('due_since')}}</span> 
              <span class="cb-u-invoice__strong cb-u-invoice__middle">{{dueDate(item.due_date)}}</span>
              <span class="cb-u-invoice__tag" v-if="overdueDays(item.due_date)">{{overdueDays(item.due_date)}}</span>
            </div>
            <div class="cb-u-invoice__detail cb-u-invoice__nodisplaymq" v-if="billingPeriod(item)"><span class="cb-u-invoice__middle">{{st('billing_period')}}</span> <span class="cb-u-invoice__strong cb-u-invoice__middle">{{billingPeriod(item)}}</span></div>
            <div class="cb-u-invoice__detail cb-u-invoice__nodisplaymq" v-if="canShowMandateText && item.subscription_id"><span class="cb-u-invoice__middle">Subscription ID</span> <span class="cb-u-invoice__strong cb-u-invoice__middle">{{item.subscription_id}}</span></div>
          </div>
          <div class="cb-u-invoice__action cb-transition__fade" @click="downloadInvoice(item.id)" v-cb-link = "'color'" v-if="!isDownloading(item.id)" data-cb-id="paynow_download_invoice">
            {{st('download_pdf')}}
          </div>
          <div v-else class="cb-u-invoice__action">
            <div v-for = "i in 3" v-bind:key="i" class="cb-u-invoice__loader cb-transition__fade" :style="backgroundColor">
            </div>
          </div>
        </li>
        <li v-cb-link = "'color'" class="cb-u-invoice__list cb-u-invoice__more" @click="loadMore()" v-if="canShowLoadMore()" :class="{'cb-button__loader': invoice_loading_in_progress, 'cb-button__loader--black' : invoice_loading_in_progress}">
        Load More
        </li>
      </ul>
    </div>
    <div class="cb-pbody__footer">
      <cb-button :attr="'pay_now'" :custom-class="'primary'" @next = "next" :class="{'cb-button__disabled':btn_disabled}" :aria-disabled="btn_disabled" :btnDisabled="btn_disabled" :disabled="btn_disabled">
					{{ t("button.txt", {amount: $options.filters.cbCurrency(amountToBePaid, currency_code) }) }} <i class="icon-long-arrow-right"></i>
      </cb-button>
    </div>
  </div>
</template>
<script type="text/javascript">
import Vue from "vue"
import {
  mapGetters
} from "vuex"
import Button from "@/components/collections/form/ButtonComponent"
import apiClient from "@/utils/cb-client"
import UrlHelper from "@/utils/url-helper"
import Notes from "@/components/collections/elements/Notes"
export default {
  data(){
    return {
      month : ['Jan', 'Feb' , 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      currencyCode : "",
      invoiceArr : [],
    }
  },
  components : {
    'cb-button' : Button,
    'cb-notes': Notes,
  },
  computed: {
    ...mapGetters([
      'inited',
      'valid_invoices',
      'amountToBePaid',
      'currency_code',
      'invoices_eol',
      'invoice_loading_in_progress',
      'pm_by_mandate_enabled',
      'show_mandate_screen',
    ]),
    btn_disabled(){
      return this.amountToBePaid <= 0;
    },
    canShowMandateText() {
      // We want to show only if all invoices has subscription id
      return (this.pm_by_mandate_enabled || this.show_mandate_screen) && this.valid_invoices.every(item => item.subscription_id);
    },
    eMandateTxt() {
      return 'Regulatory guidelines require that Indian cardholders set up an e-mandate for recurring payments.  We recommend that you group invoices by subscription for payment. This way you can set up e-mandates for these subscriptions to automate future recurring payments via this payment method.'
    }
  },
  methods : {
    loadMore() {
      this.$store.dispatch('load_unpaid_invoices');
    },
    canShowLoadMore() {
      return !this.invoice_loading_in_progress && !this.invoices_eol;
    },
    isDownloading(id){
      return this.invoiceArr.indexOf(id) > -1 ? true : false;
    },
    convertTimeStampToDate(timeStamp){
      let _date = new Date(timeStamp*1000);
      return this.month[_date.getMonth()] + " " +  _date.getDate() + ", " + _date.getFullYear();
    },
    dueDate(timeStamp){
      return this.convertTimeStampToDate(timeStamp);
    },
    isFuture(timeStamp) {
      let dueTime = new Date(timeStamp*1000), currTime = new Date();
      let month = dueTime.getMonth(), date = dueTime.getDate(), year = dueTime.getFullYear();
      let currDate = currTime.getDate(), currMonth = currTime.getMonth(), currYear = currTime.getFullYear();
      if (year < currYear || month < currMonth || date < currDate) {
        return false;
      }
      return true;
    },
    overdueDays(timeStamp){
      let days = Math.round((new Date() - new Date(timeStamp*1000))/(1000*60*60*24));
      if(days <= 0){
        return;
      }
      return days ? this.st('days_overdue', {days: days}) : this.st('payment_overdue');
    },
    billingPeriod(invoice){
      let diffArray = invoice.line_items.map(k => (k.date_to - k.date_from));
      let index = diffArray.indexOf(Math.max.apply(null,diffArray));
      return diffArray[index] != 0 ? (this.convertTimeStampToDate(invoice.line_items[index].date_from) + " to " + this.convertTimeStampToDate(invoice.line_items[index].date_to)) : false;
    },
    partial_pm(invoice){
      this.$store.dispatch('mark_selected_for_pm', invoice);
    },
    next(){
      if (!~this.$route.path.indexOf('paynow')) {
        if(this.amountToBePaid <= 0){
          return;
        }
        this.$store.dispatch('set_modal',true);
        this.$router.push({
          name: "paynow"
        });
      }
  	},
    downloadInvoice(id) {
      this.invoiceArr.push(id);
      if(UrlHelper.is_iPad() || UrlHelper.is_iPhone()){
        let windowName = UrlHelper.getWindow();
        windowName && !windowName.closed && windowName.close();
      }
      if(UrlHelper.is_iPad()) {
        let windowName = window.open("/assets/hp_v3/iframe_views/loader.html", '_blank');
        UrlHelper.setWindow(windowName);
      }
      else if(UrlHelper.is_iPhone()){
        let windowName = window.open("/assets/hp_v3/iframe_views/loader.html", "cb-invoice");
        UrlHelper.setWindow(windowName);
      }
      apiClient.customers.download_invoice({
        invoiceId: id
      })
      .then(data => {
        this.invoiceArr.splice( this.invoiceArr.indexOf(id), 1 );
        var url = data.download.download_url;
        UrlHelper.downloadUrl(url);
      }).catch(error => {
        this.invoiceArr.splice( this.invoiceArr.indexOf(id), 1 );
        logger.e(error);
        // TODO proper flash message;
      });
    }
  },
  mounted(){
    // Why setting default currency code to USD
    if(window.isMobile){
      this.$refs.wrap.style.minHeight = (window.innerHeight - document.getElementById("cb-pheader").clientHeight)+ "px";
    }
  }
}
</script>
